import { inject, Injectable } from '@angular/core';
import { Config } from '../../environments/config.model';
import { HttpClient, HttpContext } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BYPASS_SPINNER } from '../core/interceptors/loading.interceptor';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config: Config | undefined;
  private http = inject(HttpClient);

  constructor() {}

  loadConfig(url: string): Promise<void> {
    return new Promise((resolve) => {
      // This call runs on every page load (APP_INITIALIZER), so it must never drive the
      // global loading overlay: ngx-spinner creates the overlay ~10ms after show() and
      // removes it ~10ms after hide(). When both happen in the same animation frame the
      // overlay is left behind in the DOM, invisible but full screen, and it swallows
      // every click of the page until it is reloaded.
      const context = new HttpContext().set(BYPASS_SPINNER, true);
      this.http.get<Config>(url, { context }).pipe(map(res => res))
        .subscribe(config => {
          this.config = config;
          // @ts-ignore
          resolve();
        });
    });
  }

  get(): Config {
    return this.config!;
  }
}
